import type { SVGProps } from 'react';
const DawnFlagIQ = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-IQ_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-IQ_svg__a)">
      <path fill="#DF1E35" d="M0 5.333h22V0H0z" />
      <path fill="#262626" d="M0 16h22v-5.333H0z" />
      <path
        fill="#0F7A40"
        d="M14.667 6.944c0-.25.263-.41.485-.297l.38.194a.33.33 0 0 1 .183.297v2.129c0 .184-.15.333-.334.333h-.38a.333.333 0 0 1-.334-.333zM8.38 6.944c0-.25.264-.41.485-.297l.381.194a.33.33 0 0 1 .182.297v2.129c0 .184-.149.333-.333.333h-.38a.333.333 0 0 1-.334-.333zM12.571 7.138c0-.126.07-.24.182-.297l.381-.194a.333.333 0 0 1 .485.297v2.323c0 .184-.15.333-.333.333h-.381a.333.333 0 0 1-.334-.333z"
      />
      <path
        fill="#0F7A40"
        d="M10.477 8.204c0-.125.07-.24.182-.297l.38-.194a.333.333 0 0 1 .485.297v.571h1.572V9.6H10.81a.333.333 0 0 1-.333-.333zM6.286 8.204c0-.125.07-.24.182-.297l.381-.194a.333.333 0 0 1 .485.297v.571h1.571V9.6H6.62a.333.333 0 0 1-.333-.333z"
      />
    </g>
  </svg>
);
export default DawnFlagIQ;
